import React, { Fragment } from 'react';
import classnames from 'classnames';
import Line from '../components/Line';
import HeightGuarantee from '../components/HeightGuarantee';
import { breakpoints, isBreakpoint } from '../utils';
import {
  useWindowSize,
  useBreakpoint,
  useBreakpointValue
} from '../utils/hooks';

import * as css from './ProjectIntro.module.css';

const ProjectIntro = ({ frontmatter, clientLogos }) => {
  const { description, client, release, urls, meta } = frontmatter;

  const [winWidth] = useWindowSize();
  const breakpoint = useBreakpoint(winWidth);
  const patternX = useBreakpointValue(breakpoint, {
    large: '50%',
    largest: null
  });

  const keys = Object.keys(meta || {});

  return (
    <div>
      <div className={css.cols}>
        <div className={css.left}>
          <Line isFlexbox={true} patternX="100%" spacing={true} />
        </div>
        <div className={css.middle}>
          <HeightGuarantee breakpoint={breakpoints.contained}>
            <p className={css.description}>{description}</p>
          </HeightGuarantee>
          {isBreakpoint(breakpoint, 'large') && <Line patternX={'50%'} />}
        </div>
        <div className={css.right}>
          <HeightGuarantee breakpoint={breakpoints.contained}>
            <Row>
              {client &&
                [].concat(client).map((client, i) => <p key={i}>{client}</p>)}
            </Row>
          </HeightGuarantee>

          {release && (
            <>
              <Line patternX={patternX} />
              <HeightGuarantee breakpoint={breakpoints.contained}>
                <Row label="Release">{release}</Row>
              </HeightGuarantee>
            </>
          )}
          {keys.map((key, i) => {
            return (
              <Fragment key={key + i}>
                <Line patternX={patternX} />
                <HeightGuarantee breakpoint={breakpoints.contained}>
                  <Row label={key}> {meta[key]}</Row>
                </HeightGuarantee>
              </Fragment>
            );
          })}
          {urls &&
            Object.keys(urls).map((prettyUrl, i) => {
              return (
                <Fragment key={i}>
                  <Line patternX={patternX} />
                  <HeightGuarantee breakpoint={breakpoints.contained}>
                    <Row>
                      <a
                        href={urls[prettyUrl]}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {prettyUrl}
                      </a>
                    </Row>
                  </HeightGuarantee>
                </Fragment>
              );
            })}

          {clientLogos && clientLogos.length > 0 && (
            <Fragment>
              <Line patternX={patternX} />
              <HeightGuarantee breakpoint={breakpoints.contained}>
                <Row
                  className={css.clientLogos}
                  wrapperClassName={css.clientLogosWrapper}
                >
                  {clientLogos.map((logo, i) =>
                    logo ? (
                      <div key={i} className={css.clientLogo}>
                        {logo}
                      </div>
                    ) : null
                  )}
                </Row>
              </HeightGuarantee>
            </Fragment>
          )}

          {!isBreakpoint(breakpoint, 'large') && (
            <Line patternX={patternX} isFlexbox />
          )}
        </div>
      </div>
      <Line patternX="50%" />
    </div>
  );
};

const Row = ({ label, large, className, wrapperClassName, children }) => {
  return (
    <>
      <div
        className={classnames(css.row, wrapperClassName, {
          [css.large]: large
        })}
      >
        {label && <div className={css.label}>{label}</div>}
        <div className={classnames(css.rowContent, className)}>{children}</div>
      </div>
    </>
  );
};

export default ProjectIntro;
